import React, { FC } from "react";
import { Box, Button } from "@chakra-ui/react";

interface IGrsPendingLeadLoadErrorProps {
  id: string;
  message: string;
  onRetry: () => void;
}

export const GrsPendingLeadLoadError: FC<IGrsPendingLeadLoadErrorProps> = ({
  id,
  message,
  onRetry,
}) => {
  return (
    <Box role={"alert"} id={id}>
      <Box mb={3}>{message}</Box>
      <Button size={"sm"} onClick={onRetry}>
        Try again
      </Button>
    </Box>
  );
};
